<template>
  <div class="login-box">
    <div class="center-box">
      <div class="login-content">
        <img src="~@/assets/login/login-bg.png" alt="" class="login-bg" />
        <div class="login-fill_box">
          <div class="login-tips">
            目前支持登录系统：专修单修，pccm科规范化建设，联合体官网，互联网医院
          </div>
          <div class="login-title">用户登录</div>
          <div class="login_line">
            <img src="~@/assets/login/phone.png" alt="" class="login_icon" />
            <div class="login_cont">
              <input
                type="number"
                class="login_input"
                v-model="phone"
                placeholder="请输入手机号"
              />
            </div>
          </div>
          <template v-if="loginType === '1'">
            <div class="login_line">
              <img
                src="~@/assets/login/password.png"
                alt=""
                class="login_icon"
              />
              <div class="login_cont">
                <input
                  type="text"
                  class="login_input"
                  v-model="code"
                  placeholder="请输入验证码"
                />
                <div class="get-code" @click="clickCodeBtn">
                  {{ isCounting ? timeCount + "s" : "获取验证码" }}
                </div>
              </div>
            </div>
          </template>
          <template v-if="loginType === '2'">
            <div class="login_line">
              <img
                src="~@/assets/login/password.png"
                alt=""
                class="login_icon"
              />
              <div class="login_cont">
                <input
                  type="text"
                  class="login_input"
                  v-model="password"
                  placeholder="请输入密码"
                />
              </div>
            </div>
          </template>

          <div
            :class="['login_btn', is_submit ? 'disable' : '']"
            @click="clickLoginBtn"
          >
            登录
          </div>
          <div
            class="reg_btn"
            @click="toRegister"
          >
            立即注册
          </div>
          <div class="login_small-btn-box">
            <template v-if="loginType === '1'">
              <div class="login_small-btn" @click="changeLoginType('2')">
                密码登录
              </div>
            </template>
            <template v-if="loginType === '2'">
              <div class="login_small-btn" @click="changeLoginType('1')">
                验证码登录
              </div></template
            >
            <div class="login_small-btn" @click="toForget">忘记密码</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fetchLogin } from "@/api/login";
import { fetchSendSms } from "@/api/user";
import { setToken, getToken } from "@/utils/auth";
import { mapState, mapMutations } from "vuex";
import todoMixin from "@/mixins/todoMixin";
import codeMixin from "@/mixins/codeMixin";
import { fetchSubLogin } from "@/api/login";
export default {
  name: "Login",
  mixins: [todoMixin, codeMixin],
  computed: {
    ...mapState("user", ["redirect", "platform", "role"]),
  },
  data() {
    return {
      // 登录类型 1验证码登录 2密码登陆
      loginType: "2",
      phone: "",
      password: "",
      code: "",
      is_submit: false,
    };
  },
  mounted() {
    const { redirect = "", platform = "", role = "" } = this.$route.query;
    this["SET_DATA"]({
      redirect,
      platform,
      role,
    });
    let exist_common_token = getToken();
    if (exist_common_token) {
      fetchSubLogin({
        platform,
        role,
        common_token: exist_common_token,
      }).then((res) => {
        const { code, data } = res;
        if (code === 0) {
          const { do: todo } = data;
          this["SET_DATA"]({
            login_todo: todo,
          });
          this.handleTodo(todo);
        }
      });
    } else {
      this["CLEAR_DATA"]();
    }
  },
  beforeDestroy() {
    this.destroyTimer();
  },
  methods: {
    ...mapMutations("user", ["SET_DATA", "CLEAR_DATA"]),
    checkSms() {
      const { phone } = this;
      if (!phone) {
        this.$message({
          message: "请输入手机号",
          type: "error",
        });
        return false;
      }
      return true;
    },
    fetchSmsApi() {
      const { phone } = this;
      fetchSendSms({
        phone,
      });
    },
    clickLoginBtn() {
      const {
        phone,
        loginType,
        code,
        password,
        is_submit,
        platform = "",
        role = "",
        redirect = "",
      } = this;
      if (is_submit) return;
      let submits = {
        phone,
        code: "",
        password: "",
        platform,
        role,
        redirect,
      };
      if (!phone) {
        this.$message({
          message: "请输入手机号 ",
          type: "error",
        });
        return;
      }
      if (loginType === "1") {
        if (!code) {
          this.$message({
            message: "请输入验证码",
            type: "error",
          });
          return;
        }
        submits.code = code;
      } else if (loginType === "2") {
        if (!password) {
          this.$message({
            message: "请输入密码",
            type: "error",
          });
          return;
        }
        submits.password = password;
      }
      this.is_submit = true;

      fetchLogin(submits)
        .then((res) => {
          this.is_submit = false;
          console.log(res);
          const { code, data, msg } = res;
          if (code === 0) {
            //登录成功
            const { do: todo, common_token, common_user } = data;
            const { name, hospital_name, avatar } = common_user;
            setToken(common_token);
            this["SET_DATA"]({
              name: name ? name : "",
              phone,
              hospital_name: hospital_name ? hospital_name : "",
              avatar: avatar ? avatar : "",
              login_todo: todo,
              common_token,
            });

            this.handleTodo(todo, true);
          } else if (code === 1) {
            //登录失败

            const { do: todo } = data;
            if (!todo) {
              this.$message({
                message: msg,
                type: "error",
              });
            } else {
              this.handleTodo(todo, false);
            }
          }
        })
        .catch(() => {
          this.is_submit = false;
        });
    },
    //更改登录方式
    changeLoginType(type = "1") {
      this.loginType = type;
    },
    toForget() {
      this.$router.push({
        name: "ForgetPassword",
        query:{
          platform:this.platform,
          role:this.role,
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
